
import { Vue, Component } from "vue-property-decorator";
import RightClickMenuItem from "@/components/Canvas/OverlaidUI/Canvas/RightClickMenuItem.vue";
import Icon from "@/components/UI/Icon.vue";
import { configStore, documentStore, uiStore } from "@/store/store-accessor";

type WrapItem = {
  label: string;
  elementSlug: string;
};

@Component({
  components: {
    Icon,
    RightClickMenuItem
  }
})
export default class RightClickWrapMenu extends Vue {
  wrapItems: WrapItem[] = [
    {
      label: "Div",
      elementSlug: "EssentialElements\\Div"
    },
    {
      label: "Link",
      elementSlug: "EssentialElements\\WrapperLink"
    }
  ];

  get element() {
    return uiStore.activeElement;
  }

  get canWrap() {
    if (!this.element) return false;

    const element = configStore.element(this.element.data.type);
    const nesting = element.nestingRule.type;

    return ![
      "section",
      "root",
      "popup",
      "final-that-is-allowed-inside-root"
    ].includes(nesting);
  }

  wrapIn({ elementSlug }: WrapItem) {
    if (!this.element) return;

    documentStore.wrapElement({
      wrapperElementSlug: elementSlug,
      elementId: this.element.id
    });

    uiStore.setOnCanvasRightClickMenuState("closed");
  }
}
